
import router from "@/router";
import { useStore } from "vuex";
import { computed} from '@vue/runtime-core';
import { useRoute } from 'vue-router';
import Dialog from "primevue/dialog";
import '../../assets/sass/components/DocumentosLegales/_popUpHabilitacion.scss';

export default {
  name: "PopUpHabilitacion",
  components: {
    Dialog,
  },
  props: {
    habProcesoRestringido: String
  },
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const sinSalidaDePlans = computed(() => {
        return localStorage.getItem("DatosContactoRedireccion") === "Plans" && route.name == 'Plans'
      });

    const CerrarModal = () => {
      if (props.habProcesoRestringido == 'Planes' || props.habProcesoRestringido == 'Ajuste') {
        router.push('Transmission');
      }
      else {
        emit('actualizarMostrarPopUpHabilitacion', false);
      }
    };

    const RedirigirHabilitacion = () => {
      router.push('QualificationDelcop');
    }

    return {
      store,
      CerrarModal,
      RedirigirHabilitacion,
      sinSalidaDePlans
    };
  }
}
